import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTE_CHECKOUT } from '../constants';
import { armCheckoutStarted } from './pulseCheckoutId';

/** Re-arm checkout_started when user leaves checkout so the next visit can fire again. */
export const useResetCheckoutStartedOnLeave = (): void => {
  const { pathname } = useLocation();
  const prevPathRef = useRef(pathname);

  useEffect(() => {
    const prev = prevPathRef.current;
    if (prev.includes(ROUTE_CHECKOUT) && !pathname.includes(ROUTE_CHECKOUT)) {
      armCheckoutStarted();
    }
    prevPathRef.current = pathname;
  }, [pathname]);
};
